module.exports = __webpack_public_path__ + "static/media/rootModifiedAerial.d3bd1916.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rootModifiedAerial.png
// module id = 332
// module chunks = 0